(() => {
  'use strict';
  if (window.__ROCKY_COLLECTION_7__) return;
  window.__ROCKY_COLLECTION_7__ = true;

  const initCollection = root => {
    const sections = [];
    if (root?.matches?.('[data-rk7-collection]')) sections.push(root);
    root?.querySelectorAll?.('[data-rk7-collection]').forEach(section => sections.push(section));

    sections.forEach(section => {
      if (section.dataset.rk7Ready === 'true') return;
      section.dataset.rk7Ready = 'true';

      const grid = section.querySelector('#RK7CollectionGrid');
      const loader = section.querySelector('[data-rk7-loader]');
      const more = section.querySelector('[data-rk7-load-more]');
      const status = section.querySelector('[data-rk7-load-status]');
      let loading = false;
      let observer;
      const loaded = new Set();
      const loadNext = async event => {
        event?.preventDefault();
        const href = more?.getAttribute('href');
        if (loading || !href || loaded.has(href)) return;
        loading = true;
        observer?.unobserve(loader);
        status.textContent = status.dataset.loading;
        grid.setAttribute('aria-busy', 'true');
        more.setAttribute('aria-disabled', 'true');
        try {
          const url = new URL(href, location.href);
          url.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('collection-load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = doc.querySelector('#RK7CollectionGrid');
          if (!nextGrid?.children.length) throw new Error('collection-grid');
          const known = new Set([...grid.querySelectorAll('[data-rk5-card]')].map(card => card.dataset.productId));
          [...nextGrid.children].forEach(card => {
            if (card.dataset.productId && known.has(card.dataset.productId)) return;
            grid.append(card);
          });
          loaded.add(href);
          const next = doc.querySelector('[data-rk7-load-more]')?.getAttribute('href');
          status.textContent = '';
          if (next) { more.setAttribute('href', next); observer?.observe(loader); }
          else { more.removeAttribute('href'); loader.hidden = true; observer?.disconnect(); }
          document.dispatchEvent(new CustomEvent('rocky:products-loaded', { detail: { root: grid } }));
        } catch {
          status.textContent = status.dataset.error;
        } finally {
          loading = false;
          grid.removeAttribute('aria-busy');
          more.removeAttribute('aria-disabled');
        }
      };
      if (grid && more && loader && 'IntersectionObserver' in window) {
        section.querySelector('.rk7-pagination')?.setAttribute('hidden', '');
        more.addEventListener('click', loadNext);
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) loadNext();
        }, { rootMargin: '500px 0px' });
        if (!loader.hidden) observer.observe(loader);
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }

      const form = section.querySelector('[data-rk7-filter-form]');
      const drawer = section.querySelector('[data-rk7-filter-drawer]');
      const backdrop = section.querySelector('.rk7-filters__backdrop');
      const openButton = section.querySelector('[data-rk7-filter-open]');
      const closeButtons = section.querySelectorAll('[data-rk7-filter-close]');
      const details = [...section.querySelectorAll('[data-rk7-filter]')];
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const chatWidget = document.querySelector('#wfb-wrapper');

      const closeDrawer = () => {
        drawer?.classList.remove('is-open');
        backdrop?.classList.remove('is-open');
        document.documentElement.classList.remove('rk7-filters-open');
        chatWidget?.style.removeProperty('visibility');
        chatWidget?.style.removeProperty('opacity');
        chatWidget?.style.removeProperty('pointer-events');
        openButton?.setAttribute('aria-expanded', 'false');
        window.setTimeout(() => openButton?.focus(), 0);
      };

      const openDrawer = () => {
        if (!drawer || !backdrop) return;
        drawer.classList.add('is-open');
        backdrop.classList.add('is-open');
        document.documentElement.classList.add('rk7-filters-open');
        chatWidget?.style.setProperty('visibility', 'hidden', 'important');
        chatWidget?.style.setProperty('opacity', '0', 'important');
        chatWidget?.style.setProperty('pointer-events', 'none', 'important');
        openButton?.setAttribute('aria-expanded', 'true');
        drawer.querySelector('[data-rk7-filter-close]')?.focus();
      };

      openButton?.setAttribute('aria-expanded', 'false');
      openButton?.addEventListener('click', openDrawer);
      closeButtons.forEach(button => button.addEventListener('click', closeDrawer));

      details.forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (!detail.open || mobileQuery.matches) return;
          details.forEach(item => {
            if (item !== detail) item.open = false;
          });
        });
      });

      document.addEventListener('click', event => {
        if (mobileQuery.matches) return;
        details.forEach(detail => {
          if (detail.open && !detail.contains(event.target)) detail.open = false;
        });
      });

      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (drawer?.classList.contains('is-open')) closeDrawer();
        details.forEach(detail => {
          detail.open = false;
        });
      });

      mobileQuery.addEventListener('change', event => {
        if (!event.matches) closeDrawer();
      });

      section.querySelector('[data-rk7-sort]')?.addEventListener('change', () => form?.requestSubmit());
      form?.addEventListener('submit', () => form.classList.add('is-loading'));
    });
  };

  const init = () => initCollection(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => initCollection(event.target));
})();
